import React from 'react';
import FindIdContainer from '../components/FindId/FindIdContainer';

const FindIdPage = () => {
  return <FindIdContainer />;
};

export default FindIdPage;
